import React, { Component } from 'react';
import { Row, Col, Modal, Form } from 'react-bootstrap';
import moment from 'moment';
import './_calendar.scss';

// ─── Static mock data (swap with API) ─────────────────────────────────────────
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTHS_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const TIMETABLE = {
  0: [],
  1: [
    { id: 'mon1', t: '08:30', end: '09:25', subject: 'Linear Algebra', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-201', section: 'Sec-A · Yr II' },
    { id: 'mb1', break: true, t: '09:25', end: '09:30', title: 'Short Break' },
    { id: 'mon2', t: '09:30', end: '10:25', subject: 'Data Structures', teacher: 'Dr. K. Rao', room: 'Lab-3', code: 'CS-202', section: 'Sec-A · Yr II' },
    { id: 'mb2', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'mon3', t: '10:45', end: '11:40', subject: 'Discrete Mathematics', teacher: 'Prof. S. Mehta', room: 'B-110', code: 'MA-203', section: 'Sec-A · Yr II' },
    { id: 'mon4', t: '11:45', end: '12:40', subject: 'Technical Writing', teacher: 'Ms. A. Fernandes', room: 'A-301', code: 'EN-101', section: 'Sec-A · Yr II' },
    { id: 'mlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'mon5', t: '13:30', end: '15:25', subject: 'Physics Laboratory', teacher: 'Dr. V. Joshi', room: 'Lab-1', code: 'PH-202', section: 'Sec-A · Yr II' },
  ],
  2: [
    { id: 'tue1', t: '08:30', end: '09:25', subject: 'Probability Theory', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-204', section: 'Sec-A · Yr II' },
    { id: 'tue2', t: '09:30', end: '10:25', subject: 'Operating Systems', teacher: 'Dr. P. Khanna', room: 'B-115', code: 'CS-301', section: 'Sec-A · Yr II' },
    { id: 'tb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'tue3', t: '10:45', end: '11:40', subject: 'Algorithms', teacher: 'Dr. K. Rao', room: 'B-220', code: 'CS-303', section: 'Sec-A · Yr II' },
    { id: 'tue4', t: '11:45', end: '12:40', subject: 'Economics', teacher: 'Prof. M. Dutta', room: 'A-204', code: 'HU-101', section: 'Sec-A · Yr II' },
    { id: 'tlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'tue5', t: '13:30', end: '15:25', subject: 'Programming Lab', teacher: 'Dr. P. Khanna', room: 'Lab-2', code: 'CS-301L', section: 'Sec-A · Yr II' },
  ],
  3: [
    { id: 'wed1', t: '08:30', end: '09:25', subject: 'Linear Algebra', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-201', section: 'Sec-B · Yr II' },
    { id: 'wed2', t: '09:30', end: '10:25', subject: 'Algorithms', teacher: 'Dr. K. Rao', room: 'B-220', code: 'CS-303', section: 'Sec-B · Yr II' },
    { id: 'wb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'wed3', t: '10:45', end: '11:40', subject: 'Database Systems', teacher: 'Prof. R. Singh', room: 'B-118', code: 'CS-304', section: 'Sec-B · Yr II' },
    { id: 'wed4', t: '11:45', end: '12:40', subject: 'Discrete Mathematics', teacher: 'Prof. S. Mehta', room: 'B-110', code: 'MA-203', section: 'Sec-B · Yr II' },
    { id: 'wlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'wed5', t: '13:30', end: '15:25', subject: 'DBMS Lab', teacher: 'Prof. R. Singh', room: 'Lab-4', code: 'CS-304L', section: 'Sec-B · Yr II' },
  ],
  4: [
    { id: 'thu1', t: '08:30', end: '09:25', subject: 'Operating Systems', teacher: 'Dr. P. Khanna', room: 'B-115', code: 'CS-301', section: 'Sec-A · Yr II' },
    { id: 'thu2', t: '09:30', end: '10:25', subject: 'Probability Theory', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-204', section: 'Sec-A · Yr II' },
    { id: 'thb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'thu3', t: '10:45', end: '11:40', subject: 'Database Systems', teacher: 'Prof. R. Singh', room: 'B-118', code: 'CS-304', section: 'Sec-A · Yr II' },
    { id: 'thu4', t: '11:45', end: '12:40', subject: 'Technical Writing', teacher: 'Ms. A. Fernandes', room: 'A-301', code: 'EN-101', section: 'Sec-A · Yr II' },
    { id: 'thlunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'thu5', t: '13:30', end: '14:25', subject: 'Mentor Hour', teacher: 'Class Mentor', room: 'A-101', code: '—', section: 'All sections' },
    { id: 'thu6', t: '14:30', end: '15:25', subject: 'Self Study', teacher: 'Independent', room: 'Library', code: '—', section: 'All' },
  ],
  5: [
    { id: 'fri1', t: '08:30', end: '09:25', subject: 'Algorithms', teacher: 'Dr. K. Rao', room: 'B-220', code: 'CS-303', section: 'Sec-A · Yr II' },
    { id: 'fri2', t: '09:30', end: '10:25', subject: 'Economics', teacher: 'Prof. M. Dutta', room: 'A-204', code: 'HU-101', section: 'Sec-A · Yr II' },
    { id: 'fb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'fri3', t: '10:45', end: '12:40', subject: 'Project Workshop', teacher: 'Dr. K. Rao + Team', room: 'Lab-5', code: 'CS-399', section: 'All sections' },
    { id: 'flunch', break: true, t: '12:40', end: '13:30', title: 'Lunch Break' },
    { id: 'fri4', t: '13:30', end: '15:25', subject: 'Sports / Clubs', teacher: 'Open', room: 'Grounds', code: '—', section: 'All' },
  ],
  6: [
    { id: 'sat1', t: '08:30', end: '09:25', subject: 'Tutorial', teacher: 'Prof. N. Iyer', room: 'B-204', code: 'MA-201T', section: 'Sec-A · Yr II' },
    { id: 'sat2', t: '09:30', end: '10:25', subject: 'Tutorial', teacher: 'Prof. S. Mehta', room: 'B-205', code: 'MA-201T', section: 'Sec-B · Yr II' },
    { id: 'sb1', break: true, t: '10:25', end: '10:45', title: 'Short Break' },
    { id: 'sat3', t: '10:45', end: '11:40', subject: 'Make-up Class', teacher: 'Open slot', room: 'B-204', code: '—', section: 'As assigned' },
    { id: 'sat4', t: '11:45', end: '12:40', subject: 'Admin / Reports', teacher: 'Faculty Room', room: 'F-12', code: '—', section: '—' },
  ],
};

const DATE_META = {
  '2026-5-15': { type: 'holiday', title: 'State Holiday', note: 'Campus closed' },
  '2026-5-20': { type: 'exam', title: 'Mid-Term Exams', note: 'Begins · Block A & B' },
  '2026-5-25': { type: 'event', title: 'Annual Sports Day', note: 'All-day event · Grounds' },
  '2026-6-1':  { type: 'holiday', title: 'Foundation Day', note: 'College holiday' },
  '2026-6-15': { type: 'exam', title: 'End-Sem Exams', note: 'All departments' },
};

const MOCK_STUDENTS = [
  { id: 1, name: 'Aarav Sharma', rollNo: 'CS21001' },
  { id: 2, name: 'Priya Patel', rollNo: 'CS21002' },
  { id: 3, name: 'Vikram Mehta', rollNo: 'CS21003' },
  { id: 4, name: 'Sneha Iyer', rollNo: 'CS21004' },
  { id: 5, name: 'Rohan Das', rollNo: 'CS21005' },
  { id: 6, name: 'Anita Singh', rollNo: 'CS21006' },
  { id: 7, name: 'Kiran Kumar', rollNo: 'CS21007' },
  { id: 8, name: 'Meera Joshi', rollNo: 'CS21008' },
  { id: 9, name: 'Arjun Reddy', rollNo: 'CS21009' },
  { id: 10, name: 'Pooja Nair', rollNo: 'CS21010' },
  { id: 11, name: 'Siddharth Roy', rollNo: 'CS21011' },
  { id: 12, name: 'Kavya Menon', rollNo: 'CS21012' },
];

// ─── Pure helpers ─────────────────────────────────────────────────────────────
function metaKey(d) { return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`; }
function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function classify(date) {
  const k = metaKey(date);
  if (DATE_META[k]) return DATE_META[k];
  if (date.getDay() === 0) return { type: 'holiday', title: 'Sunday', note: 'Weekly off' };
  return { type: 'working', title: 'Working day', note: 'Regular schedule' };
}
function getPeriods(date) {
  const meta = classify(date);
  if (meta.type === 'holiday') return [];
  return TIMETABLE[date.getDay()] || [];
}
function periodCount(date) { return getPeriods(date).filter(p => !p.break).length; }
function toMins(t) { const [h, m] = t.split(':').map(Number); return h * 60 + m; }
function durText(t, end) {
  const m = toMins(end) - toMins(t);
  if (m >= 60) { const h = Math.floor(m / 60), mm = m % 60; return mm ? `${h}h ${mm}m` : `${h}h`; }
  return `${m}m`;
}
function totalClassTime(date) {
  let m = 0;
  getPeriods(date).filter(p => !p.break).forEach(p => { m += toMins(p.end) - toMins(p.t); });
  const h = Math.floor(m / 60), mm = m % 60;
  if (!m) return '0h';
  if (h && mm) return `${h}h ${mm}m`;
  return h ? `${h}h` : `${mm}m`;
}
function uniqueRooms(date) {
  return new Set(getPeriods(date).filter(p => !p.break).map(p => p.room)).size;
}
function getInitials(name) {
  return name.replace(/\(.*\)/g, '').split(/[\s.]+/).filter(Boolean).slice(-2).map(s => s[0]).join('').toUpperCase().slice(0, 2) || '··';
}
function nowState(date) {
  const today = new Date();
  if (!isSameDay(date, today)) return null;
  const nowMins = today.getHours() * 60 + today.getMinutes();
  const periods = getPeriods(date);
  for (let i = 0; i < periods.length; i++) {
    const p = periods[i];
    if (p.break) continue;
    const start = toMins(p.t), end = toMins(p.end);
    if (nowMins >= start && nowMins < end) {
      let next = null;
      for (let j = i + 1; j < periods.length; j++) { if (!periods[j].break) { next = periods[j]; break; } }
      return { state: 'in', current: p, progress: (nowMins - start) / (end - start), minsLeft: end - nowMins, next };
    }
    if (nowMins < start) return { state: 'before', upcoming: p, minsUntil: start - nowMins };
  }
  return { state: 'after' };
}

// ─── Component ────────────────────────────────────────────────────────────────
class CalendarSection extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      today,
      selectedDate: today,
      calMonth: today.getMonth(),
      calYear: today.getFullYear(),
      liveClock: this._clock(),

      showAddModal: false,
      addForm: {
        date: moment(today).format('YYYY-MM-DD'),
        type: 'event',
        title: '',
        note: '',
        startTime: '',
        endTime: '',
      },
      addSuccess: false,

      showAttModal: false,
      attPeriod: null,
      attendance: {},
      savedAttendance: {},
      attSubmitted: false,

      localMeta: {},
    };
  }

  _clock() {
    const d = new Date();
    return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  }

  componentDidMount() {
    this._interval = setInterval(() => {
      this.setState({ liveClock: this._clock() });
      if (isSameDay(this.state.selectedDate, this.state.today)) this.forceUpdate();
    }, 30000);
  }

  componentWillUnmount() { clearInterval(this._interval); }

  selectDate = (d) => this.setState({ selectedDate: d });
  prevMonth = () => this.setState(s => {
    let m = s.calMonth - 1, y = s.calYear;
    if (m < 0) { m = 11; y--; }
    return { calMonth: m, calYear: y };
  });
  nextMonth = () => this.setState(s => {
    let m = s.calMonth + 1, y = s.calYear;
    if (m > 11) { m = 0; y++; }
    return { calMonth: m, calYear: y };
  });
  goToToday = () => {
    const t = new Date();
    this.setState({ selectedDate: t, calMonth: t.getMonth(), calYear: t.getFullYear() });
  };

  // ─── Add event ──────────────────────────────────────────────────────────────
  openAddModal = (date) => {
    this.setState(s => ({
      showAddModal: true,
      addSuccess: false,
      addForm: {
        ...s.addForm,
        date: moment(date || s.selectedDate).format('YYYY-MM-DD'),
        title: '', note: '', startTime: '', endTime: '',
      },
    }));
  };
  closeAddModal = () => this.setState({ showAddModal: false });
  setAddForm = (k, v) => this.setState(s => ({ addForm: { ...s.addForm, [k]: v } }));
  submitAdd = (e) => {
    e.preventDefault();
    const { addForm, localMeta } = this.state;
    const parts = addForm.date.split('-');
    const key = `${parseInt(parts[0])}-${parseInt(parts[1])}-${parseInt(parts[2])}`;
    const newMeta = {
      ...localMeta,
      [key]: { type: addForm.type, title: addForm.title, note: addForm.note },
    };
    DATE_META[key] = newMeta[key];
    this.setState({ localMeta: newMeta, addSuccess: true });
    setTimeout(() => this.setState({ showAddModal: false, addSuccess: false }), 1600);
  };

  // ─── Attendance ──────────────────────────────────────────────────────────────
  openAttModal = (period) => {
    const existing = (this.state.savedAttendance[period.id] || {});
    const att = {};
    MOCK_STUDENTS.forEach(s => { att[s.id] = existing[s.id] || 'P'; });
    this.setState({ showAttModal: true, attPeriod: period, attendance: att, attSubmitted: false });
  };
  closeAttModal = () => this.setState({ showAttModal: false });
  toggleAtt = (sid, status) => this.setState(s => ({ attendance: { ...s.attendance, [sid]: status } }));
  markAllAtt = (status) => {
    const att = {};
    MOCK_STUDENTS.forEach(s => { att[s.id] = status; });
    this.setState({ attendance: att });
  };
  submitAtt = () => {
    const { attPeriod, attendance, savedAttendance } = this.state;
    this.setState({
      savedAttendance: { ...savedAttendance, [attPeriod.id]: { ...attendance } },
      attSubmitted: true,
    });
    setTimeout(() => this.setState({ showAttModal: false, attSubmitted: false }), 1500);
  };

  // ─── Mini calendar render ────────────────────────────────────────────────────
  renderMiniCal() {
    const { calMonth, calYear, selectedDate, today } = this.state;
    const first = new Date(calYear, calMonth, 1);
    const last = new Date(calYear, calMonth + 1, 0);
    const lead = (first.getDay() + 6) % 7;

    const cells = [];
    for (let i = lead; i > 0; i--) cells.push({ date: new Date(calYear, calMonth, 1 - i), out: true });
    for (let d = 1; d <= last.getDate(); d++) cells.push({ date: new Date(calYear, calMonth, d), out: false });
    const need = (Math.ceil(cells.length / 7)) * 7 - cells.length;
    for (let i = 1; i <= need; i++) cells.push({ date: new Date(calYear, calMonth + 1, i), out: true });

    return (
      <div className="cal-panel">
        <div className="cal-panel-head">
          <span className="cal-panel-title">{MONTHS[calMonth]} <span className="year">{calYear}</span></span>
          <div className="cal-nav-btns">
            <button className="cal-icon-btn" onClick={this.prevMonth} title="Previous">‹</button>
            <button className="cal-icon-btn" onClick={this.goToToday} title="Today">•</button>
            <button className="cal-icon-btn" onClick={this.nextMonth} title="Next">›</button>
          </div>
        </div>
        <div className="mini-cal-body">
          <div className="mini-dow-row">
            {['M','T','W','T','F','S','S'].map((d, i) => (
              <span key={i} className={i === 6 ? 'weekend' : ''}>{d}</span>
            ))}
          </div>
          <div className="mini-grid">
            {cells.map((cell, idx) => {
              if (cell.out) return <div key={idx} className="mday outside"><span className="mday-num">{cell.date.getDate()}</span></div>;
              const meta = classify(cell.date);
              const isT = isSameDay(cell.date, today);
              const isSel = isSameDay(cell.date, selectedDate);
              const pc = periodCount(cell.date);
              let cls = 'mday';
              if (meta.type !== 'working') cls += ` ${meta.type}`;
              if (isT) cls += ' today';
              if (isSel) cls += ' selected';
              return (
                <div key={idx} className={cls} onClick={() => this.selectDate(cell.date)}>
                  <span className="mday-num">{cell.date.getDate()}</span>
                  {pc > 0 && <span className="mday-count">{pc}p</span>}
                  {meta.type !== 'working' && <span className="mday-dot" />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // ─── Upcoming panel ──────────────────────────────────────────────────────────
  renderUpcoming() {
    const { today } = this.state;
    const items = [];
    for (let i = 0; i < 30; i++) {
      const d = new Date(today); d.setDate(d.getDate() + i);
      const k = metaKey(d);
      if (DATE_META[k]) items.push({ date: new Date(d), meta: DATE_META[k], days: i });
    }
    return (
      <div className="cal-panel">
        <div className="cal-panel-head">
          <span className="cal-panel-title">Upcoming</span>
          <span className="cal-panel-subtitle">Next 30 days</span>
        </div>
        {items.length === 0
          ? <div style={{ padding: '20px 16px', fontSize: 12, color: '#71717a' }}>No upcoming events.</div>
          : (
            <div className="upcoming-list">
              {items.slice(0, 6).map((item, idx) => {
                const rel = item.days === 0 ? 'Today' : item.days === 1 ? 'Tomorrow' : `${item.days}d`;
                return (
                  <div
                    key={idx}
                    className={`upcoming-item ${item.meta.type}`}
                    onClick={() => this.setState({
                      selectedDate: item.date,
                      calMonth: item.date.getMonth(),
                      calYear: item.date.getFullYear(),
                    })}
                  >
                    <div className="up-date">
                      <span className="up-dnum">{item.date.getDate()}</span>
                      <span className="up-dmo">{MONTHS_SHORT[item.date.getMonth()]}</span>
                    </div>
                    <div className="up-info">
                      <div className="up-title">{item.meta.title}</div>
                      <div className="up-sub">{item.meta.note}</div>
                    </div>
                    <span className="up-rel">{rel}</span>
                  </div>
                );
              })}
            </div>
          )
        }
      </div>
    );
  }

  // ─── Now / Next strip ────────────────────────────────────────────────────────
  renderNowStrip(ns, meta, isToday) {
    if (!isToday) {
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-calendar-day" /></div>
          <div className="now-text">
            <div className="now-label idle">Schedule</div>
            <div className="now-name">{DAYS[this.state.selectedDate.getDay()]} Timetable</div>
            <div className="now-meta">Viewing {moment(this.state.selectedDate).format('DD MMM YYYY')}</div>
          </div>
        </div>
      );
    }
    if (meta.type === 'holiday') {
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-umbrella-beach" /></div>
          <div className="now-text">
            <div className="now-label idle">Holiday</div>
            <div className="now-name">{meta.title}</div>
            <div className="now-meta">{meta.note}</div>
          </div>
        </div>
      );
    }
    if (!ns || ns.state === 'after') {
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-check-circle" /></div>
          <div className="now-text">
            <div className="now-label idle">Day complete</div>
            <div className="now-name">All classes finished for today</div>
            <div className="now-meta">Enjoy the rest of your day</div>
          </div>
          <div className="now-clock">{this.state.liveClock}</div>
        </div>
      );
    }
    if (ns.state === 'before') {
      const m = ns.minsUntil;
      return (
        <div className="now-strip idle">
          <div className="now-icon idle"><i className="fal fa-clock" /></div>
          <div className="now-text">
            <div className="now-label idle">Up next</div>
            <div className="now-name">{ns.upcoming.subject}</div>
            <div className="now-meta">{ns.upcoming.teacher} · {ns.upcoming.room}</div>
          </div>
          <div className="now-time-wrap">
            <div className="now-time-val">{ns.upcoming.t}</div>
            <div className="now-time-sub">{m < 60 ? `in ${m}m` : `in ${Math.floor(m / 60)}h ${m % 60}m`}</div>
          </div>
        </div>
      );
    }
    const pct = Math.round(ns.progress * 100);
    return (
      <div className="now-strip active">
        <div className="now-icon active"><i className="fal fa-bolt" /></div>
        <div className="now-text">
          <div className="now-label active"><span className="now-dot" />Live now</div>
          <div className="now-name">{ns.current.subject}</div>
          <div className="now-meta">{ns.current.teacher} · {ns.current.room} · {ns.current.code}</div>
        </div>
        <div className="now-time-wrap">
          <div className="now-time-val">Ends {ns.current.end}</div>
          <div className="now-time-sub">{pct}% complete</div>
        </div>
        <div className="now-progress-bar">
          <div className="now-progress-fill" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }

  // ─── Period list ─────────────────────────────────────────────────────────────
  renderPeriods() {
    const { selectedDate, today, savedAttendance } = this.state;
    const periods = getPeriods(selectedDate);
    const meta = classify(selectedDate);
    const isToday = isSameDay(selectedDate, today);
    const nowMins = new Date().getHours() * 60 + new Date().getMinutes();

    if (meta.type === 'holiday') {
      return (
        <div className="empty-state">
          <div className="empty-icon"><i className="fal fa-calendar-times" /></div>
          <h5>{meta.title}</h5>
          <p>{meta.note}</p>
        </div>
      );
    }
    if (periods.length === 0) {
      return (
        <div className="empty-state">
          <div className="empty-icon"><i className="fal fa-calendar" /></div>
          <h5>No classes scheduled</h5>
          <p>Nothing configured for this day</p>
        </div>
      );
    }

    let pn = 0;
    return (
      <div className="period-list">
        {periods.map((p, idx) => {
          if (p.break) {
            return (
              <div key={idx} className="period break">
                <div className="p-time-col"><span className="p-start">{p.t} – {p.end}</span></div>
                <div className="p-info"><span className="break-title">{p.title}</span></div>
              </div>
            );
          }
          pn++;
          const start = toMins(p.t), end = toMins(p.end);
          const isNow = isToday && nowMins >= start && nowMins < end;
          const isPast = isToday && nowMins >= end;
          const hasAtt = savedAttendance[p.id];
          const attPresent = hasAtt ? Object.values(hasAtt).filter(v => v === 'P').length : 0;
          const attTotal = MOCK_STUDENTS.length;
          let cls = 'period';
          if (isNow) cls += ' now-period';
          else if (isPast) cls += ' past-period';

          return (
            <div key={idx} className={cls}>
              <div className="p-time-col">
                <span className="p-start">{p.t}</span>
                <span className="p-end">– {p.end}</span>
                <span className="p-dur">{durText(p.t, p.end)}</span>
              </div>
              <div className="p-avatar">{getInitials(p.teacher)}</div>
              <div className="p-info">
                <div className="p-title-row">
                  <span className="p-num">P{pn}</span>
                  <span className="p-title">{p.subject}</span>
                  {isNow && <span className="live-badge">Live</span>}
                </div>
                <div className="p-meta-row">
                  <span className="p-code">{p.code}</span>
                  <span className="p-sep">·</span>
                  <span className="p-teacher">{p.teacher}</span>
                  {p.section && <><span className="p-sep">·</span><span className="p-section">{p.section}</span></>}
                </div>
                {hasAtt && (
                  <div className="att-summary">
                    <i className="fal fa-check-circle" style={{ marginRight: 4 }} />
                    {attPresent}/{attTotal} Present · Attendance saved
                  </div>
                )}
              </div>
              <div className="p-actions">
                <div className="p-room">
                  <i className="fal fa-door-open" style={{ marginRight: 4, fontSize: 10 }} />{p.room}
                </div>
                {!hasAtt && isPast && (
                  <button className="mark-att-btn urgent" onClick={() => this.openAttModal(p)}>
                    <i className="fal fa-user-check" /> Mark
                  </button>
                )}
                {!hasAtt && isNow && (
                  <button className="mark-att-btn live-btn" onClick={() => this.openAttModal(p)}>
                    <i className="fal fa-user-check" /> Mark Now
                  </button>
                )}
                {!hasAtt && !isNow && !isPast && (
                  <button className="mark-att-btn" onClick={() => this.openAttModal(p)}>
                    <i className="fal fa-user-check" /> Attendance
                  </button>
                )}
                {hasAtt && (
                  <button className="mark-att-btn done-btn" onClick={() => this.openAttModal(p)}>
                    <i className="fal fa-edit" /> Edit
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // ─── Add event modal ─────────────────────────────────────────────────────────
  renderAddModal() {
    const { showAddModal, addForm, addSuccess } = this.state;
    const typeColors = { event: '#36a1f5', holiday: '#c0533a', exam: '#b07a10' };
    return (
      <Modal show={showAddModal} onHide={this.closeAddModal} centered size="md" className="cal-modal">
        <Modal.Header closeButton>
          <Modal.Title>Add Calendar Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addSuccess ? (
            <div style={{ textAlign: 'center', padding: '32px 0' }}>
              <div style={{ fontSize: 38, color: '#3d8a55' }}>✓</div>
              <h5 style={{ fontWeight: 700, marginTop: 12 }}>Entry Added!</h5>
              <p style={{ color: '#6b6b78', fontSize: 13 }}>"{addForm.title}" has been saved to the calendar.</p>
            </div>
          ) : (
            <Form onSubmit={this.submitAdd}>
              <Row>
                <Col md={7}>
                  <Form.Group style={{ marginBottom: 14 }}>
                    <label className="cal-form-label">Date *</label>
                    <Form.Control type="date" value={addForm.date} onChange={e => this.setAddForm('date', e.target.value)} required className="cal-form-input" />
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group style={{ marginBottom: 14 }}>
                    <label className="cal-form-label">Entry Type *</label>
                    <Form.Control as="select" value={addForm.type} onChange={e => this.setAddForm('type', e.target.value)} className="cal-form-input">
                      <option value="event">📅 Event</option>
                      <option value="holiday">🏖️ Holiday</option>
                      <option value="exam">📝 Exam</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group style={{ marginBottom: 14 }}>
                <label className="cal-form-label">Title *</label>
                <Form.Control
                  type="text"
                  placeholder={addForm.type === 'holiday' ? 'e.g., Independence Day' : addForm.type === 'exam' ? 'e.g., Mid-Term Exams' : 'e.g., Annual Sports Day'}
                  value={addForm.title}
                  onChange={e => this.setAddForm('title', e.target.value)}
                  required className="cal-form-input"
                />
              </Form.Group>
              <Form.Group style={{ marginBottom: 14 }}>
                <label className="cal-form-label">Note / Description</label>
                <Form.Control
                  as="textarea" rows={2}
                  placeholder="Short description..."
                  value={addForm.note}
                  onChange={e => this.setAddForm('note', e.target.value)}
                  className="cal-form-input"
                />
              </Form.Group>
              {addForm.type === 'exam' && (
                <Row>
                  <Col md={6}>
                    <Form.Group style={{ marginBottom: 14 }}>
                      <label className="cal-form-label">Start Time</label>
                      <Form.Control type="time" value={addForm.startTime} onChange={e => this.setAddForm('startTime', e.target.value)} className="cal-form-input" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group style={{ marginBottom: 14 }}>
                      <label className="cal-form-label">End Time</label>
                      <Form.Control type="time" value={addForm.endTime} onChange={e => this.setAddForm('endTime', e.target.value)} className="cal-form-input" />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 6, paddingTop: 12, borderTop: '1px solid #e8e9ef' }}>
                <button type="button" onClick={this.closeAddModal} className="cal-outline-btn">Cancel</button>
                <button type="submit" className="cal-primary-btn" style={{ background: typeColors[addForm.type] }}>
                  <i className="fal fa-plus" style={{ marginRight: 5 }} />
                  Add {addForm.type.charAt(0).toUpperCase() + addForm.type.slice(1)}
                </button>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    );
  }

  // ─── Attendance modal ─────────────────────────────────────────────────────────
  renderAttModal() {
    const { showAttModal, attPeriod, attendance, attSubmitted } = this.state;
    if (!attPeriod) return null;
    const present = Object.values(attendance).filter(v => v === 'P').length;
    const absent = Object.values(attendance).filter(v => v === 'A').length;
    const late = Object.values(attendance).filter(v => v === 'L').length;

    return (
      <Modal show={showAttModal} onHide={this.closeAttModal} centered size="lg" className="cal-modal att-modal">
        <Modal.Header closeButton>
          <div>
            <Modal.Title style={{ fontSize: 15 }}>
              Attendance — {attPeriod.subject}
            </Modal.Title>
            <div style={{ fontSize: 12, color: '#6b6b78', marginTop: 2 }}>
              {attPeriod.t} – {attPeriod.end} &nbsp;·&nbsp; {attPeriod.room} &nbsp;·&nbsp; {attPeriod.code}
              {attPeriod.section && <>&nbsp;·&nbsp; {attPeriod.section}</>}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="att-modal-body">
          {attSubmitted ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <div style={{ fontSize: 40, color: '#3d8a55' }}>✓</div>
              <h5 style={{ fontWeight: 700, marginTop: 12 }}>Attendance Saved!</h5>
              <p style={{ color: '#6b6b78', fontSize: 13 }}>
                {present} Present &nbsp;·&nbsp; {absent} Absent &nbsp;·&nbsp; {late} Late
              </p>
            </div>
          ) : (
            <>
              <div className="att-summary-bar">
                <div className="att-stat present"><span className="att-stat-num">{present}</span><span className="att-stat-lbl">Present</span></div>
                <div className="att-stat absent"><span className="att-stat-num">{absent}</span><span className="att-stat-lbl">Absent</span></div>
                <div className="att-stat late"><span className="att-stat-num">{late}</span><span className="att-stat-lbl">Late</span></div>
                <div className="att-mark-all-btns">
                  <button className="mark-all-btn p" onClick={() => this.markAllAtt('P')}>All Present</button>
                  <button className="mark-all-btn a" onClick={() => this.markAllAtt('A')}>All Absent</button>
                </div>
              </div>
              <div className="att-student-list">
                {MOCK_STUDENTS.map(stu => {
                  const st = attendance[stu.id] || 'P';
                  return (
                    <div key={stu.id} className="att-student-row">
                      <div className="att-student-info">
                        <div className="att-student-avatar">
                          {stu.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
                        </div>
                        <div>
                          <div className="att-student-name">{stu.name}</div>
                          <div className="att-student-roll">{stu.rollNo}</div>
                        </div>
                      </div>
                      <div className="att-toggle-group">
                        {[['P', 'Present'], ['A', 'Absent'], ['L', 'Late']].map(([code, label]) => (
                          <button
                            key={code}
                            className={`att-toggle ${st === code ? `active-${code}` : ''}`}
                            onClick={() => this.toggleAtt(stu.id, code)}
                          >{label}</button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="att-submit-bar">
                <button className="att-submit-btn" onClick={this.submitAtt}>
                  <i className="fal fa-save" style={{ marginRight: 6 }} />
                  Save Attendance ({MOCK_STUDENTS.length} students)
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }

  // ─── Main render ─────────────────────────────────────────────────────────────
  render() {
    const { selectedDate, today, liveClock } = this.state;
    const meta = classify(selectedDate);
    const isToday = isSameDay(selectedDate, today);
    const ns = nowState(selectedDate);
    const pc = periodCount(selectedDate);

    let heroTitle = DAYS[selectedDate.getDay()];
    if (isToday) heroTitle = 'Today';
    else if (isSameDay(selectedDate, new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1))) heroTitle = 'Tomorrow';
    else if (isSameDay(selectedDate, new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1))) heroTitle = 'Yesterday';

    return (
      <div className="cal-wrap">
        {/* Page header */}
        <div className="cal-page-header">
          <div>
            <h4 className="cal-page-title">Academic Calendar</h4>
            <p className="cal-page-sub">View timetable, manage academic events &amp; mark attendance</p>
          </div>
          <div className="cal-header-actions">
            <div className="cal-live-pill">
              <span className="live-dot" />
              {liveClock}
            </div>
            <button className="cal-outline-btn" onClick={this.goToToday}>
              <i className="fal fa-crosshairs" style={{ marginRight: 5 }} />Today
            </button>
            <button className="cal-primary-btn" onClick={() => this.openAddModal()}>
              <i className="fal fa-plus" style={{ marginRight: 5 }} />Add Entry
            </button>
          </div>
        </div>

        <Row style={{ marginLeft: 0, marginRight: 0 }}>
          {/* Left: schedule */}
          <Col xl={8} lg={7} md={12} style={{ paddingLeft: 0, paddingRight: 8 }}>
            <div className="cal-hero">
              <div className="hero-head">
                <div>
                  <div className="hero-title-row">
                    <h3 className="hero-title">{heroTitle}</h3>
                    <span className={`cal-badge ${meta.type}`}>{meta.title}</span>
                  </div>
                  <div className="hero-sub">
                    {DAYS[selectedDate.getDay()]} · {selectedDate.getDate()} {MONTHS[selectedDate.getMonth()]} {selectedDate.getFullYear()}
                  </div>
                </div>
                <div className="hero-stats">
                  <div className="hstat">
                    <span className="hstat-v">{pc}</span>
                    <span className="hstat-l">Periods</span>
                  </div>
                  <div className="hstat">
                    <span className="hstat-v">{totalClassTime(selectedDate)}</span>
                    <span className="hstat-l">Class time</span>
                  </div>
                  <div className="hstat">
                    <span className="hstat-v">{uniqueRooms(selectedDate)}</span>
                    <span className="hstat-l">Locations</span>
                  </div>
                </div>
              </div>
              {this.renderNowStrip(ns, meta, isToday)}
              {this.renderPeriods()}
            </div>
          </Col>

          {/* Right: mini cal + upcoming */}
          <Col xl={4} lg={5} md={12} style={{ paddingLeft: 8, paddingRight: 0 }}>
            <div className="cal-side">
              {this.renderMiniCal()}
              {this.renderUpcoming()}
              {/* Quick add button in sidebar */}
              <button
                className="cal-primary-btn"
                style={{ width: '100%', justifyContent: 'center', height: 40, borderRadius: 10, fontSize: 13 }}
                onClick={() => this.openAddModal()}
              >
                <i className="fal fa-plus" style={{ marginRight: 6 }} />Add Holiday / Exam / Event
              </button>
            </div>
          </Col>
        </Row>

        {this.renderAddModal()}
        {this.renderAttModal()}
      </div>
    );
  }
}

export default CalendarSection;
